import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  descriptionBox: {
    backgroundColor: theme.palette.primary.light,
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(2),
    borderRadius: 4,
  },
  paperBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  containerButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}))

export default useStyles
